// wx 类 代理类，调取接口，配置成功的后续操作都在这里
import WX from "./wx";
import Http from "../fetchApp/fetch"; // 请求
import { WX_JSTICKET } from "../api"; // 接口名

const wx = WX.getInstance();

// 通过接口获取key，调取单例wx类的配置
function config() {
  return new Promise((resolve, reject) => {
    if (!wx.isNeedConfig()) {
      resolve();
    } else {
      Http.post(WX_JSTICKET, {
        url: window.location.href
      })
        .then(res => {
          console.log("wxconfig", res);
          // 判断状态码
          if (res.code === 0) {
            const { appId, signature, timestamp, nonceStr } = res.data;
            const jsApiList = [
              "onMenuShareWeibo",
              "onMenuShareQZone",
              "startRecord",
              "stopRecord",
              "onVoiceRecordEnd",
              "playVoice",
              "pauseVoice",
              "stopVoice",
              "onVoicePlayEnd",
              "uploadVoice",
              "downloadVoice",
              "chooseImage",
              "previewImage",
              "uploadImage",
              "downloadImage",
              "translateVoice",
              "getNetworkType",
              "openLocation",
              "getLocation",
              "hideOptionMenu",
              "showOptionMenu",
              "hideMenuItems",
              "showMenuItems",
              "hideAllNonBaseMenuItem",
              "showAllNonBaseMenuItem",
              "closeWindow",
              "scanQRCode",
              "chooseWXPay",
              "openProductSpecificView",
              "addCard",
              "chooseCard",
              "openCard",
              "onMenuShareTimeline",
              "onMenuShareAppMessage",
              "onMenuShareQQ"
            ];
            const openTagList = ['wx-open-launch-app']
            return wx.config({
              debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              appId, // 必填，公众号的唯一标识
              timestamp, // 必填，生成签名的时间戳
              nonceStr, // 必填，生成签名的随机串
              signature, // 必填，签名
              jsApiList, // 必填，需要使用的JS接口列表
              openTagList // 微信开放标签
            });
          } else {
            reject(new Error("状态码异常"));
          }
        })
        .then(() => {
          resolve();
        })
        .catch(err => {
          reject(err);
        });
    }
  });
}

/**
 * 分享
 * @param  {Object}  options
 * @param  {String}  options.title 分享标题
 * @param  {Object}  options.desc 分享描述
 * @param  {Object}  options.url 分享链接
 * @param  {Object}  options.img  分享缩略图
 * @return {promise} 返回一个是否成功分享的promise
 */
/*
 * 微信分享的格式不一样，所以在代理类转一下格式
 * title = '', // 分享标题
 * desc = '', // 分享描述
 * link = '', // 分享链接
 * imgUrl = '' // 分享图标
 * */
export function share(options) {
  config().then(() => {
    console.log("配置成功", options);
    options.link = options.url || "";
    options.imgUrl = options.img || "";
    wx.share(options);
  });
}

const install = Vue => {
  Vue.prototype.$wx = {
    share
  };
};

export default {
  install
};
